/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {Order} from './Order';

/**
 * The RegisterOrderResponse model module.
 * @module model/RegisterOrderResponse
 * @version v1
 */
export class RegisterOrderResponse {
  /**
   * Constructs a new <code>RegisterOrderResponse</code>.
   * @alias module:model/RegisterOrderResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>RegisterOrderResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/RegisterOrderResponse} obj Optional instance to populate.
   * @return {module:model/RegisterOrderResponse} The populated <code>RegisterOrderResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new RegisterOrderResponse();
      if (data.hasOwnProperty('status'))
        obj.status = ApiClient.convertToType(data['status'], 'String');
      if (data.hasOwnProperty('order'))
        obj.order = Order.constructFromObject(data['order']);
    }
    return obj;
  }
}

/**
 * @member {String} status
 */
RegisterOrderResponse.prototype.status = undefined;

/**
 * @member {module:model/Order} order
 */
RegisterOrderResponse.prototype.order = undefined;

